exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip[data-v-a92ac980]{\n    opacity: 1 !important;\n}\n", ""]);

// exports
